export default __webpack_public_path__ + "static/media/task-empty.8d8d6088.png";